import { useState } from 'react'
import VideoGridView from './VideoGridView'
import VideoListView from './VideoListView'

const VideoList = ({className}) => {
  const [gridView, setGridView] = useState(true)

  if (gridView) {
    return <VideoGridView className={className} close={() => setGridView(false)} />
  }
  return (
    <VideoListView className={className} close={() => setGridView(true)} />
  )
}

export default VideoList
